<template>
  <!-- Tabela com os itens que deverão ser avaliados -->
  <v-data-table
    :headers="headers"
    :items="value"
    :items-per-page="-1"
    class="mt-4"
    hide-default-footer
    hide-default-header
  >
    <!-- Nome do avaliado -->
    <template v-slot:[`item.avaliado`]="{ item }">{{ item.avaliacao.avaliado.nome }}</template>

    <!-- Nota -->
    <template v-slot:[`item.rating`]="{ item }">
      <app-rating
        :value="item.nota"
        :disabled="disabled"
        :tamanho="value.length > 1 ? 28 : 36"
        @return="item.naoAplica = false"
      />
    </template>

    <!-- Avaliação não se aplica ao servidor -->
    <template v-slot:[`item.switch`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div style="display: inline-block" v-on="on">
            <v-switch
              v-model="item.naoAplica"
              class="text-md-right"
              label="Não se aplica"
              dense
              @change="item.nota.rating = 0"
            />
          </div>
        </template>
        <span>Assinale a opção NÃO SE APLICA quando a responsabilidade não for executada pelo(a) avaliado(a)</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import AppRating from '@/components/core/AppRating';

export default {
  name: 'AvaliacaoFormList',

  components: { AppRating },

  props: {
    value: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    tipo: {
      type: String,
      required: true,
    },
    perspectiva: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    headers() {
      const headers = [
        {
          text: '',
          sortable: false,
          value: 'rating',
          align: 'end',
          width: '15%',
        },
      ];

      if (this.value.length > 1) {
        headers.splice(0, 0, { text: 'AVALIADO', value: 'avaliado', sortable: false });
      }

      if (this.tipo === 'SUBORDINADO' && this.perspectiva === 'RESPONSABILIDADE') {
        headers.push({
          text: '',
          sortable: false,
          value: 'switch',
          align: 'end',
          width: '15%',
        });
      }

      return headers;
    },
  },
};
</script>
